import { getUserTimezone } from './GetUserTimezone'

export function normalizePollTimestampToToday(lastPollTimestamp: string): string {
  const userTimezone = getUserTimezone()

  const last = new Date(lastPollTimestamp)

  // Extract time parts from the old timestamp (UTC)
  const hours = last.getUTCHours()
  const minutes = last.getUTCMinutes()
  const seconds = last.getUTCSeconds()
  const ms = last.getUTCMilliseconds()

  // Get "today" in user's timezone
  const now = new Date()
  const todayInUserTZ = new Intl.DateTimeFormat('en-CA', {
    timeZone: userTimezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now) // YYYY-MM-DD

  const [year, month, day] = todayInUserTZ.split('-').map(Number)

  // Construct new UTC date using today's date + old time
  const normalized = new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds, ms))

  return normalized.toISOString()
}
